angular.module("siter.io").factory 'errorsInterceptor', ['$q', "$injector", ($q, $injector) ->
  response =
    responseError: (rejection) ->
      if rejection.status == 423
        Billing = $injector.get "Billing"
        $modalStack = $injector.get "$modalStack"
        $modalStack.dismissAll()
        Billing.constraints()
      if rejection.status == 500
        Notification = $injector.get "Notification"
        Notification.error message: 'Неизвестная ошибка на сервере (500)'
      $q.reject rejection
  response
]



// WEBPACK FOOTER //
// ./src/app/common/services/errorsInterceptor.service.coffee